import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "after", "before", "classes", "fieldState", "initialValue", "message", "label", "type", "color", "icon", "errorPass", "value", "required", "invalid"];
import React from "react";
import { BasicText, asField } from "informed";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { FieldIcons } from "../Field";
import defaultClasses from "./textInput.module.scss";
import Icon from "../../../../components/Icon";
var TextInput = _ref => {
  var {
      id,
      after,
      before,
      classes: propClasses,
      fieldState,
      initialValue,
      message,
      label,
      type,
      color,
      icon,
      errorPass,
      value,
      required,
      invalid
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = mergeClasses(defaultClasses, propClasses);
  var iconInputOk = /*#__PURE__*/React.createElement(Icon, {
    name: "icon-check",
    color: "green",
    className: "uk-form-icon uk-form-icon-flip"
  });
  var isInputWhite = color === "white" ? "white" : "";
  var inputError = errorPass ? classes.error : "";
  var labelError = errorPass ? classes.error_label : "";
  return /*#__PURE__*/React.createElement(FieldIcons, {
    after: after
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-box-shadow-medium float-labels uk-border-rounded ".concat(isInputWhite)
  }, before, icon ? iconInputOk : null, /*#__PURE__*/React.createElement(BasicText, _extends({}, rest, {
    required: required,
    fieldState: fieldState,
    initialValue: initialValue,
    className: "uk-input uk-form-large ".concat(inputError),
    id: id,
    type: type,
    placeholder: label
  })), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "floating-label section-rounded ".concat(labelError)
  }, label)));
};
export default asField(TextInput);